// جسر بسيط بين منطق فتح التقرير (JS عادي) ومُضيف الطبقة داخل React.
// يسمح بعرض HTML التقرير داخل التطبيق نفسه بلا مغادرة الصفحة.
let opener = null;
let current = null;

export const registerReportOpener = (fn) => {
  opener = fn;
};

export const openReportOverlay = (p) => {
  current = p;
  if (opener) {
    opener(p);
    return true;
  }
  return false;
};

// تحديث جزئي للطبقة المفتوحة (إضافة pdfUrl/shareUrl لاحقاً) دون إعادة تحميل الـ iframe.
export const patchReportOverlay = (partial) => {
  if (!current || !opener) return;
  current = { ...current, ...partial };
  opener(current);
};

export const closeReportOverlay = () => {
  current = null;
  if (opener) opener(null);
};
